<div class="modal-header">Debugging Information</div>
<div class="modal-body">
  <p>Firm ID: {{ firmId }}</p>
  <p>Session ID: {{ sessionId }}</p>
  <p>Contact ID: {{ contactId }}</p>
  <p>Case ID: {{ caseId }}</p>
  <p>Document ID: {{ documentId }}</p>
  <p>Answer Pool ID: {{ answerPoolId }}</p>
  <p>AppInsights Session ID: {{ appInsightsSessionId }}</p>
  <div class="selected-field">
    <ul>
      Selected Field - Details:
        <li>Token: {{ selectedField!.details.name }}</li>
        <li>Index: {{ selectedField!.details.id }}</li>
        <li>Answer: {{ getDetailsText() }}</li>
    </ul>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn" (click)="activeModal.dismiss()">Close</button>
</div>

